import store from "@/store";
import Vue from "vue";

// Actually fully incorrect because language != locale (ISO3166), but works, in our case, for now, because short designator nl, es and es can resolve to valid locales.
const resolveLocaleFromLanguage = (language = "en") => {
    return language;
};

export const formatDate = (value, formatting = { month: "numeric", day: "numeric", year: "numeric" }) => {
    const luxon = Vue.prototype.$luxon.DateTime;

    // If we like to format times, automatically applies the correct clock cycle (12h/24h)
    if (formatting.hasOwnProperty("hour")) {
        formatting.hourCycle = `h${
            parseInt(store.state.appConfig.timeNotation) === 24 ? 23 : store.state.appConfig.timeNotation
        }`;
    }

    return luxon
        .fromISO(value)
        .setLocale(resolveLocaleFromLanguage(store.state.appConfig.language))
        .toLocaleString(formatting);
};

export const toRelative = (value) => {
    const luxon = Vue.prototype.$luxon.DateTime;

    return luxon.fromISO(value).setLocale(resolveLocaleFromLanguage(store.state.appConfig.language)).toRelative();
};

export const diff = (date1, date2) => {
    const firstDate = Vue.prototype.$luxon.DateTime.fromISO(date1);
    const secondDate = Vue.prototype.$luxon.DateTime.fromISO(date2);

    return firstDate.diff(secondDate).toObject();
};

// https://moment.github.io/luxon/demo/global.html
/** @deprecated please use VueUse timeAgo if possible. @see https://vueuse.org/core/useTimeAgo */
export const timeAgo = (chatDatetime, unit = "seconds") => {
    const now = Vue.prototype.$luxon.DateTime.now();
    const chatDate = Vue.prototype.$luxon.DateTime.fromISO(chatDatetime);

    const difference = now.diff(chatDate, unit).toObject()[unit];

    if (unit === "seconds" && difference > 60) {
        return timeAgo(chatDatetime, "minutes");
    }

    if (unit === "minutes" && difference > 60) {
        return timeAgo(chatDatetime, "hours");
    }

    // If more than 24 HOURS, then check difference in days.
    if (unit === "hours" && difference > 12) {
        return timeAgo(chatDatetime, "days");
    }

    // If more than 7 days, return just the date, so no differences.
    if (unit === "days" && difference > 24) {
        return chatDate.toLocaleString();
    }

    return now.minus({ [unit]: difference }).toRelative();
};
